import * as React from 'react';
import Avatar from '@mui/material/Avatar';

interface AvatarProps {
  letter?: string;         
  image?: string;          
  backgroundColor?: string; 
}

const CustomAvatar: React.FC<AvatarProps> = ({ letter, image, backgroundColor }) => {
  return (
    <Avatar
      sx={{ bgcolor: backgroundColor || "#c5c5c5", maxWidth:"30px", maxHeight:"30px" }}
      alt={letter}
      src={image}  
    >
      {!image && letter}  
    </Avatar>
  );
};

export default CustomAvatar;